import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from './CartContext.js';
import defaultImg from "../../components/images/defaultPerson.png";
import { getAnnouncements } from '../../services/memberApiServices.js';
import ViewAnnouncement from './ViewAnnouncement.js';
import { MDBBadge, MDBBtn, MDBCard, MDBCardBody, MDBCardImage, MDBContainer, MDBTypography } from 'mdb-react-ui-kit';
import ViewProfile from './ViewProfile.js';

const Header = ({ title, iscart, }) => {
    const navigate = useNavigate();
    // const [cart, setCart] = useState(null);
    const { cart, getItemCount, getMemberUrl, getMemberName, getGymId } = useCart();
    const handleCartClick = () => {
        navigate("/viewcart");
    }

    const [showAllAnnouncements, setShowAllAnnouncements] = useState(false);
    const [activeAnnouncement, setActiveAnnouncement] = useState([]);
    const [announcements, setAnnouncements] = useState([])
    const [showProfile, setShowProfile] = useState(false)
    useEffect(() => {

        const fetchAnnounceData = async () => {

            const res = await getAnnouncements(getGymId())
            if (!res || res == "false") {
                return
            }
            const recinfo = await res.json();
            // console.log(recinfo);
            if (recinfo.length > 0) {
                setAnnouncements(recinfo)
                const today = new Date();
                const todayStr = today.toISOString().split('T')[0]; // e.g. "2025-08-07"

                const todayAnnouncements = recinfo.filter(item => {
                    const createdDateStr = new Date(item.createdAt).toISOString().split('T')[0];
                    return createdDateStr === todayStr;
                });

                setActiveAnnouncement(todayAnnouncements);
            }

        }
        if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {

            // navigate('/memberlogin', { state: { path: '/memberdashboard' } })
        } else {
            fetchAnnounceData()
        }

    }, [getGymId])
    const handleClose = () => {
        setShowAllAnnouncements(false)
    }
    return (
        <>

            <div className="header-container">
                <div className="header-content">
                    <h4 className='m-0 main-title'>{title}</h4>
                    <span className='text-secondary'>Your Complete Activity Overview in One Place</span>
                </div>
                <div className="header-user">
                    <div className="cart-icon-container" onClick={() => setShowAllAnnouncements(true)}>
                        <i className={`fas fa-bullhorn m-0 ${showAllAnnouncements ? "icon-active" : "notification-icon"}`}></i>
                        {activeAnnouncement.length > 0 && (
                            <span className="cart-badge">
                                {activeAnnouncement.length}
                            </span>
                        )}
                    </div>
                 
                    <div className="cart-icon-container me-3" onClick={handleCartClick}>
                        <i className={`fa-sharp fa-solid fa-cart-shopping m-0 ${iscart ? "icon-active" : "notification-icon"}`}></i>
                        {getItemCount() > 0 && (
                            <span className="cart-badge">
                                {getItemCount()}
                            </span>
                        )}
                    </div>

                    {/* <i className={`fas fa-bell notification-icon`}></i> */}
                    <div className="user-avatar" onClick={() => setShowProfile(true)}>
                        <img src={getMemberUrl() ? getMemberUrl() : defaultImg} alt="User" />
                    </div>
                    <div className='user_detail'>
                        <h6 className="user-name m-0">{getMemberName()}</h6>
                        <span className="user-role text-secondary">Member</span>
                    </div>
                </div>
            </div>

            {showAllAnnouncements && <ViewAnnouncement announcements={announcements} handleClose={handleClose} />}

            {showProfile && <div className="dashboard-announcements-sidebar">
                <div className="dashboard-sidebar-header">
                    <h5 className='m-0'>Profile</h5>
                    <button
                        className="dashboard-close-sidebar"
                        onClick={() => {
                            setShowProfile(false)
                        }}
                    >
                        <i className="fa-solid fa-times"></i>
                    </button>
                </div>

              
                <ViewProfile />
            </div>}
        </>

    );
};

export default Header;